var map = {
	"./arrow.svg": 4884,
	"./features/001-responsive.svg": 8322,
	"./features/Upload-Limit.svg": 5746,
	"./features/available-to-embed.svg": 4682,
	"./features/boost-your-exposure.svg": 4075,
	"./features/custom-domain.svg": 9071,
	"./features/desktop/boost-exposure.svg": 5123,
	"./features/desktop/custom-domain.svg": 3042,
	"./features/desktop/drag-drop.svg": 2982,
	"./features/desktop/embed.svg": 8091,
	"./features/desktop/hero.jpg": 582,
	"./features/desktop/no-limit.svg": 2466,
	"./features/desktop/responsive.svg": 1295,
	"./features/drag-drop-image.svg": 9923,
	"./features/full-features-data": 5877,
	"./features/full-features-data.json": 5877,
	"./features/mobile/hero.jpg": 1706,
	"./features/tablet/hero.jpg": 2958,
	"./footer/facebook-color.svg": 5120,
	"./footer/facebook-plain.svg": 878,
	"./footer/instagram-color.svg": 323,
	"./footer/instagram-plain.svg": 1921,
	"./footer/pinterest-color.svg": 9093,
	"./footer/pinterest-plain.svg": 6582,
	"./footer/twitter-color.svg": 1907,
	"./footer/twitter-plain.svg": 7822,
	"./footer/youtube-color.svg": 6243,
	"./footer/youtube-plain.svg": 4375,
	"./home/Logo--final.svg": 2127,
	"./home/Section1_data": 5649,
	"./home/Section1_data.json": 5649,
	"./home/desktop/beautiful-stories.jpg": 6103,
	"./home/desktop/create-and-share.jpg": 3619,
	"./home/desktop/designed-for-everyone.jpg": 5424,
	"./home/mobile/beautiful-stories.jpg": 6698,
	"./home/mobile/create-and-share.jpg": 8709,
	"./home/mobile/designed-for-everyone.jpg": 6571,
	"./home/read-story": 7308,
	"./home/read-story.json": 7308,
	"./home/some_features": 5483,
	"./home/some_features.json": 5483,
	"./home/tablet/beautiful-stories.jpg": 2860,
	"./home/tablet/create-and-share.jpg": 1335,
	"./home/tablet/designed-for-everyone.jpg": 1183,
	"./pricing/desktop/check.svg": 6530,
	"./pricing/desktop/hero.jpg": 736,
	"./pricing/featuresAvailable": 1564,
	"./pricing/featuresAvailable.json": 1564,
	"./pricing/mobile/hero.jpg": 9034,
	"./pricing/pricingPlan": 1304,
	"./pricing/pricingPlan.json": 1304,
	"./pricing/tablet/hero.jpg": 4045,
	"./shared/desktop/arrow.svg": 5800,
	"./shared/desktop/bg-beta.jpg": 1312,
	"./shared/desktop/facebook.svg": 1419,
	"./shared/desktop/instagram.svg": 1689,
	"./shared/desktop/logo.svg": 1311,
	"./shared/desktop/pinterest.svg": 2923,
	"./shared/desktop/twitter.svg": 9719,
	"./shared/desktop/youtube.svg": 6661,
	"./shared/mobile/bg-beta.jpg": 4290,
	"./shared/mobile/close.svg": 4673,
	"./shared/mobile/menu.svg": 8066,
	"./shared/tablet/bg-beta.jpg": 25,
	"./stories/desktop/18-days-voyage.jpg": 3737,
	"./stories/desktop/architecturals.jpg": 9387,
	"./stories/desktop/behind-the-waves.jpg": 1656,
	"./stories/desktop/calm-waters.jpg": 5918,
	"./stories/desktop/cityscapes.jpg": 3595,
	"./stories/desktop/dark-forest.jpg": 3530,
	"./stories/desktop/king-on-africa.jpg": 2854,
	"./stories/desktop/land-of-dreams.jpg": 6742,
	"./stories/desktop/milky-way.jpg": 5181,
	"./stories/desktop/moon-of-appalacia.jpg": 5435,
	"./stories/desktop/mountains.jpg": 161,
	"./stories/desktop/rage-of-the-sea.jpg": 8211,
	"./stories/desktop/running-free.jpg": 2459,
	"./stories/desktop/somwarpet.jpg": 5697,
	"./stories/desktop/trip-to-nowhere.jpg": 4530,
	"./stories/desktop/unforeseen-corners.jpg": 2540,
	"./stories/desktop/world-tour.jpg": 4573,
	"./stories/mobile/18-days-voyage.jpg": 9657,
	"./stories/mobile/architecturals.jpg": 8219,
	"./stories/mobile/behind-the-waves.jpg": 2054,
	"./stories/mobile/calm-waters.jpg": 3454,
	"./stories/mobile/cityscapes.jpg": 7114,
	"./stories/mobile/dark-forest.jpg": 1905,
	"./stories/mobile/king-on-africa.jpg": 9609,
	"./stories/mobile/land-of-dreams.jpg": 9895,
	"./stories/mobile/milky-way.jpg": 1358,
	"./stories/mobile/moon-of-appalacia.jpg": 6420,
	"./stories/mobile/mountains.jpg": 3406,
	"./stories/mobile/rage-of-the-sea.jpg": 190,
	"./stories/mobile/running-free.jpg": 8691,
	"./stories/mobile/somwarpet.jpg": 8811,
	"./stories/mobile/trip-to-nowhere.jpg": 2834,
	"./stories/mobile/unforeseen-corners.jpg": 3803,
	"./stories/mobile/world-tour.jpg": 8437,
	"./stories/read-story-full-mobile": 7377,
	"./stories/read-story-full-mobile.json": 7377,
	"./stories/tablet/moon-of-appalacia.jpg": 1252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6379;